import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { AuthorState } from '@store/slices/author.slice'
import { fetchAllAuthors } from '@store/thunk/author.thunk'
import { moveSlot } from '@store/thunk/slot.thunk'
import {
  timeslotAdapterExport,
  TimeslotModel,
} from '@store/slices/timeslot.slice'
import { AppState } from '@store/slices/generic.slice'
import { BroadcastModel } from '@store/slices/broadcast.slice'

export const slotExtraReducers = (
  builder: ActionReducerMapBuilder<AppState<TimeslotModel>>
) => {
  builder
    .addCase(moveSlot.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(moveSlot.fulfilled, (state, action) => {
      timeslotAdapterExport.upsertMany(state, action.payload)
      state.loading = false
    })
    .addCase(moveSlot.rejected, (state) => {
      state.loading = false
      state.error = 'Posun slotu selhal'
    })
}
